// extracted by mini-css-extract-plugin
export default {"satisfaction":"SatisfactionRouts_satisfaction__8UquQ"};